export default "__VITE_ASSET__DsRomOvX__"